<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title>{{ 'MITARBEITER' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="padding-16">
    <div class="work-card padding-16 flex flex-column gap-16">
      <h2>{{ 'MITARBEITER' | translate }}</h2>
      <p>{{ 'MITARBEITER_LOGIN_INTRO' | translate }}</p>
      <work-ui-button text="LOGIN_FUER_MITARBEITENDE" [fullWidth]="true" routerLink="/auth/login" variant="secondary" />
    </div>
  </div>
</ion-content>
